import WorkoutFirstOverlay from './WorkoutFirstOverlay';

export default WorkoutFirstOverlay;
